import dynamic from 'next/dynamic';
import { useEffect, useState, type FC } from 'react';

import { Button } from '@/core/tamagoshi/Button/Button';
import { HeartBorder } from '@/core/tamagoshi/icons/HeartBorder';

import { addToWishlistLabel } from './translations';

const AddToWishListClient = dynamic(
  import('@/domains/proB2BServices/AddToWishlist/AddToWishList.client').then(
    (mod) => mod.AddToWishList,
  ),
  { ssr: false },
);

export const AddToWishList: FC = () => {
  const [displayFullComponent, setDisplayFullComponent] = useState(false);
  useEffect(() => {
    setDisplayFullComponent(true);
  }, []);

  if (displayFullComponent) return <AddToWishListClient />;
  /*
   * For now that button is only displayed on client side because
   * that's only there that we now that the user is logged in
   * so the placeholder bellow is never called but is there
   * just in case.
   */
  return (
    <Button
      icon={<HeartBorder />}
      variant="secondary"
      data-testid="addToWishlist"
      aria-label={addToWishlistLabel}
    />
  );
};
